export enum PropertyType {
  ABITATIVO = 'ABITATIVO',
  COMMERCIALE = 'COMMERCIALE',
  INDUSTRIALE = 'INDUSTRIALE',
  ALTRO = 'ALTRO',
}

/* export type PropertyType =
  | 'ABITATIVO'
  | 'COMMERCIALE'
  | 'INDUSTRIALE'
  | 'ALTRO'; */
